'use client';

import { Button } from '@/components/atoms';
import { useState } from 'react';
import { Modal } from '../Modal/Modal';
import { ReportListingForm } from '../ReportListingForm/ReportListingForm';
import { useTranslate } from '@tolgee/react';

export const ProductReportButton = () => {
  const { t } = useTranslate();
  const [openModal, setOpenModal] = useState(false);
  return (
    <>
      <Button
        className='uppercase label-md'
        variant='tonal'
        onClick={() => setOpenModal(true)}
      >
        {t("product_report_button.report_listing")}
      </Button>
      {openModal && (
        <Modal
          heading={t("product_report_button.report_listing")}
          onClose={() => setOpenModal(false)}
        >
          <ReportListingForm
            onClose={() => setOpenModal(false)}
          />
        </Modal>
      )}
    </>
  );
};
